<template>
  <v-row no-gutters>
    <v-col class="pa-0">
      <NormalDatePicker width="100%" v-model="inputedValue.start" />
    </v-col>
    <v-col class="originalCenter" cols="1"> ～ </v-col>
    <v-col>
      <NormalDatePicker width="100%" v-model="inputedValue.end" />
    </v-col>
  </v-row>
</template>

<script>
import NormalDatePicker from './NormalDatePicker'

export default {
  components: {
    NormalDatePicker
  },
  props: {
    // value: {
    //   default: {
    //     start: '',
    //     end: ''
    //   }
    // },

    value: {
      type: Object,
      require: false,
      default: () => ({
        start: '',
        end: ''
      })
    }
  },
  data: () => ({
    //
  }),
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
